'use client';

import { ICartItem } from "@/types/types";
import ProductCard from "../product/custom-product-card";
import CartProductCard from "./cart-product-card";
import { useCart } from "@/contexts/cart-context";

type CartProductListProps = {
  items: ICartItem[];
  onIncrease: (variantId: number) => void;
  onRemove: (variantId: number) => void;
  onDecrease: (variantId: number) => void;
}

const CartProductList = ({ items, onIncrease, onRemove, onDecrease }: CartProductListProps) => (
  <div className="w-full p-3.5 md:px-6 flex-col space-y-4 md:space-y-6 rounded-[20px] border border-black/10">
    {items.map((item, idx) => (
      <div key={item.variant.id}>
        <CartProductCard
          cartItem={item}
          onIncreaseItem={onIncrease}
          onRemoveItem={onRemove}
          onDecreaseItem={onDecrease}
        />
        {idx < items.length - 1 && <hr className="border-t-black/10" />}
      </div>
    ))}
  </div>
);

export default CartProductList;